import * as Layout from '../layouts'
import Store from '../../stores'

export default class AppModule {
    constructor(moduleName) {
        this.isActive = true
        this.moduleName = moduleName
        this.viewFolder = 'views'
        this.serviceFolder = 'service'
        this._routers = []
        this._store = []
    }

    store(arr) {
        this._store = arr
        if (!Array.isArray(this._store) && _.isObject(this._store))
            this._store = [this._store]

        this._store.map(store => {
            store.namespaced = true
            Store.registerModule(_.camelCase(store.name), _.omit(store, 'name'))
        })

        return this
    }

    routers(arr) {
        this._routers = arr

        return this
    }

    register(config = {}) {
        Object.assign(this, config)

        return this
    }
}

AppModule.layout = Layout
